/**
 * Gets the first 30 characters of a sessionID if it exists and is valid
 * @param sessionID - The session ID to process (can be string, undefined, or null)
 * @returns The first 30 characters of the sessionID, or undefined if invalid
 */
export function getFirst30CharsOfSessionId(sessionID: string | undefined | null): string | undefined {
    if (!sessionID || typeof sessionID !== "string") {
        return undefined;
    }
    return sessionID.substring(0, 30);
}

/**
 * Reads the GIWL landing session id from URL query params. The marketing/quote
 * service always deep-links with the `sessionId` key, so this is the single
 * source of truth for the param-name contract.
 * @param params - URLSearchParams parsed from the landing URL
 * @returns The raw session id string, or null when absent
 */
export function getSessionIdFromSearchParams(params: URLSearchParams): string | null {
    return params.get("sessionId");
}
